import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Card from "../../Card";
import {
  getSangerCosmicLicensed,
  getSangerCosmicLicensedItem,
} from "../../../../state/selectors/CosmicComponent.selectors";
import { getAMPSOMARule } from "../../../../state/selectors/AMPComponent.selectors";
import CardWrapper from "../../CardWrapper";
import { getPathogenicityColorByAllNames } from "../../../../common/helpers/Constant";
import tailwindColors from "../../../../../../tailwind.colors";
import { constructKeyValue } from "../../../../common/helpers/helpers";

const COSMICCard = ({ card, color, cosmicData, cosmicDataItem }) => {
  const backgroundColor =
    cosmicDataItem && cosmicDataItem?.num_entries < 3
      ? getPathogenicityColorByAllNames("VUS")
      : getPathogenicityColorByAllNames(color);
  const textColor =
    cosmicDataItem && cosmicDataItem.fathmm_prediction
      ? getPathogenicityColorByAllNames(cosmicDataItem.fathmm_prediction)
      : tailwindColors.gray[300];
  const topCancerLabel =
    cosmicDataItem && cosmicDataItem?.histology_freq
      ? constructKeyValue(cosmicDataItem.histology_freq)
      : null;
  return (
    <CardWrapper
      {...card}
      card={card}
      isDisabled={!Array.isArray(cosmicData) || !cosmicData.length}
      color={backgroundColor}
    >
      <>
        <div className="tw-flex">
          {cosmicDataItem && cosmicDataItem?.num_entries ? (
            <div className="tw-mr-2">
              Samples:{" "}
              <b data-testid="cosmic-total-samples">
                {cosmicDataItem.num_entries}
              </b>
            </div>
          ) : null}
          {cosmicDataItem ? (
            <div>
              Prediction:{" "}
              <b style={{ color: textColor }} data-testid="cosmic-prediction">
                {cosmicDataItem.fathmm_prediction}
              </b>
            </div>
          ) : null}
        </div>
        {topCancerLabel && topCancerLabel[0].key !== "" && (
          <div>
            Top:{" "}
            <b data-testid="cosmic-top-cancer-type">{topCancerLabel[0].key}</b>
          </div>
        )}
      </>
    </CardWrapper>
  );
};

COSMICCard.propTypes = {
  color: PropTypes.string,
  cosmicData: PropTypes.arrayOf(PropTypes.shape({})),
  cosmicDataItem: PropTypes.shape({
    num_entries: PropTypes.number,
    fathmm_prediction: PropTypes.string,
    histology_freq: PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    ),
  }),
  card: PropTypes.instanceOf(Card).isRequired,
};

COSMICCard.defaultProps = {
  color: "",
  cosmicData: [],
  cosmicDataItem: {},
};

const mapStateToProps = (state) => ({
  color: getAMPSOMARule(state),
  cosmicData: getSangerCosmicLicensed(state),
  cosmicDataItem: getSangerCosmicLicensedItem(state),
});

export default connect(mapStateToProps)(COSMICCard);
